import { Component, Input } from '@angular/core';

export interface ListingCounter {
  header: string;
  count: number;
}

@Component({
  selector: 'app-listing-counter',
  standalone: false,
  templateUrl: './listing-counter.component.html',
  styleUrl: './listing-counter.component.scss'
})
export class ListingCounterComponent {
  @Input() counters: ListingCounter[] = [];
}
